<template>
    <div>
        <h1>Places</h1>
    </div>
</template>